import { useTranslation } from 'react-i18next';

import {
  Checkbox,
  DateValue,
  UNSTABLE_DatePicker as DatePicker,
} from '@cfa/react-core';

export interface DueDateFormFieldsProps {
  checkboxClicked: boolean;
  disableDatePicker: boolean;
  onCheckboxClick: () => void;
  onDateChange: (date: DateValue | null) => void;
}

export const DueDateFormFields: React.FC<DueDateFormFieldsProps> = ({
  checkboxClicked,
  disableDatePicker,
  onCheckboxClick,
  onDateChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row justify-center">
      <div className="flex flex-col items-start justify-start text-left">
        <DatePicker
          data-testid="DatePicker"
          isDisabled={disableDatePicker}
          isRequired={!checkboxClicked}
          isInvalid={checkboxClicked ? false : undefined}
          label={t('TrainingPlans.accountability.enterDueDate')}
          onChange={onDateChange}
          shouldForceLeadingZeros={false}
        />
        <Checkbox
          data-testid="DueDateCheckbox"
          isSelected={checkboxClicked}
          onChange={onCheckboxClick}
          className="mt-8!"
        >
          {t('TrainingPlans.accountability.due.noDueDate')}
        </Checkbox>
      </div>
    </div>
  );
};
